import { Button } from '@design/components/button/Button';
import { Icon } from '@design/components/icon/Icon';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '@terminal/routes/query-params';
import {
  RankingMethodologyDrawer,
  RankingMethodologyType,
} from '@terminal/widgets/knowledge-graph-widget/components/ranking-methodology-drawer/RankingMethodologyDrawer';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './RankingMethodologySection.module.scss';

export const RankingMethodologySection = ({
  rankingType,
}: {
  rankingType: RankingMethodologyType;
}) => {
  const { t } = useTranslation(['widget']);
  const { setQueryParams } = useQueryParams();

  return (
    <>
      <RankingMethodologyDrawer />
      <div className={styles.rankingMethodologyWrapper}>
        <div className={styles.labelWrapper}>
          <Icon
            iconName="InformationCircle"
            size={20}
            fillColor="var(--icon-soft)"
          />
          <span className={styles.styledLabel}>
            {t(
              'widget:assetOverview.knowledgeGraph.themeExposure.rankIsCalculated'
            )}
          </span>
        </div>
        <Button
          className={styles.styledButton}
          variant="tertiary"
          label={t(
            'widget:assetOverview.knowledgeGraph.themeExposure.viewMethodology'
          )}
          onClick={() =>
            setQueryParams({
              [queryKeys.activeDrawer]: queryValues.rankingMethodologyDrawer,
              [queryKeys.mode]: rankingType,
            })
          }
        />
      </div>
    </>
  );
};
